export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يوافق على"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["انخفاض"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ar-EG": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يوافق على"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["انخفاض"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ar-SA": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يوافق على"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["انخفاض"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "de-DE": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zustimmen"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ablehnen"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "de-AT": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zustimmen"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ablehnen"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "de-CH": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zustimmen"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ablehnen"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "en-US": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agree"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Refuse"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "en-GB": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agree"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Decline"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "it-IT": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Essere d'accordo"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Declino"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "fr-FR": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se mettre d'accord"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Déclin"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "es-ES": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De acuerdo"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Disminución"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "pl-PL": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zgodzić się"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upadek"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "nl-NL": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mee eens"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Afwijzen"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "bg-BG": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Съгласен"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отклонение"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "bs-BA": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Slažem se"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odbij"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "da-DK": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enig"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nedgang"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "et-EE": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nõus"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keeldu"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "fi-FI": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Olla samaa mieltä"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hylkää"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "el-GR": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Συμφωνώ"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Πτώση"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "he-IL": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְהַסכִּים"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["יְרִידָה"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ga-IE": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aontaigh"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Meath"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ja-JP": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["同意する"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["低下"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "hr-HR": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pristani"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odbiti"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "lv-LV": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Piekrītu"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Noraidīt"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "lt-LT": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sutikite"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atmesti"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "pt-PT": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aceita"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Declínio"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ro-RO": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De acord"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Declin"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "ru-RU": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Согласен"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отказаться"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "sv-SE": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hålla med"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nedgång"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "sk-SK": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Súhlasím"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pokles"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "cs-CZ": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Souhlasit"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pokles"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "tr-TR": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Katılıyorum"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reddet"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "hu-HU": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Egyetért"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hanyatlás"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "fr-BE": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se mettre d'accord"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Déclin"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "fr-LU": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se mettre d'accord"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Déclin"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "mt-MT": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Naqbel"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tnaqqis"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "sl-SI": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Strinjam se"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zavrni"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "el-CY": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Συμφωνώ"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Πτώση"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "tr-CY": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Katılıyorum"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reddet"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "uk-UA": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zustimmen"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ablehnen"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "zh-CN": {
        "buttonAgree": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["同意"])}
        },
        "linkToPrivacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "buttonDeny": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["下降"])}
        },
        "privacyPolicy": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "bodyText": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      }
    }
  })
}
